<template>
  <div class="help-root bg-gray-50">
    <header class="bg-white border-b sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <img src="https://horabela.com.br/main-site/images/logo-horabela.png" alt="HoraBela" class="h-10">

        <div class="hidden md:flex flex-1 max-w-md mx-10 relative">
          <div class="relative w-full">
            <input id="search-input" v-model="searchQuery" @input="handleSearch" type="text" placeholder="O que deseja configurar hoje?" class="w-full bg-gray-100 border-none rounded-full py-2 px-10 focus:ring-2 focus:ring-[#B5836A] outline-none transition-all">
            <svg class="w-5 h-5 absolute left-3 top-2.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <div id="search-results" ref="searchResults" class="absolute top-full left-0 w-full bg-white mt-2 rounded-xl shadow-2xl hidden border border-gray-100 overflow-hidden z-[60]"></div>
        </div>

        <a href="https://wa.me/seunumero" target="_blank" class="bg-horabela-cobre text-white px-6 py-2 rounded-lg font-semibold hover:opacity-90 transition shadow-md">Suporte WhatsApp</a>
      </div>
    </header>

    <section class="bg-horabela-azul text-white py-12 px-4">
      <div class="max-w-4xl mx-auto text-center">
        <h1 class="text-3xl md:text-4xl font-bold mb-4">Central de Ajuda HoraBela</h1>
        <p class="text-gray-300">Guia prático para organizar o seu negócio de beleza sem complicações.</p>
      </div>
    </section>

    <section class="max-w-7xl mx-auto px-4 -mt-8 mb-12">
      <div class="grid grid-cols-2 lg:grid-cols-6 gap-3">
        <button @click="loadCategory('primeiros')" class="bg-white p-4 rounded-xl shadow-md border-b-4 border-horabela-cobre hover:-translate-y-1 transition text-center">
          <h3 class="font-bold text-horabela-azul text-xs">Passos Iniciais</h3>
        </button>
        <button @click="loadCategory('agenda')" class="bg-white p-4 rounded-xl shadow-md border-b-4 border-horabela-cobre hover:-translate-y-1 transition text-center">
          <h3 class="font-bold text-horabela-azul text-xs">Agenda Diária</h3>
        </button>
        <button @click="loadCategory('financeiro')" class="bg-white p-4 rounded-xl shadow-md border-b-4 border-horabela-cobre hover:-translate-y-1 transition text-center">
          <h3 class="font-bold text-horabela-azul text-xs">Comandas</h3>
        </button>
        <button @click="loadCategory('relatorios')" class="bg-white p-4 rounded-xl shadow-md border-b-4 border-horabela-cobre hover:-translate-y-1 transition text-center">
          <h3 class="font-bold text-horabela-azul text-xs">Relatórios</h3>
        </button>
        <button @click="loadCategory('gestao')" class="bg-white p-4 rounded-xl shadow-md border-b-4 border-horabela-cobre hover:-translate-y-1 transition text-center">
          <h3 class="font-bold text-horabela-azul text-xs">Gestão</h3>
        </button>
        <button @click="loadCategory('faq')" class="bg-white p-4 rounded-xl shadow-md border-b-4 border-horabela-cobre hover:-translate-y-1 transition text-center">
          <h3 class="font-bold text-horabela-azul text-xs text-horabela-cobre underline">Dúvidas (FAQ)</h3>
        </button>
      </div>
    </section>

    <main class="max-w-7xl mx-auto px-4 pb-24">
      <div class="flex flex-col md:flex-row gap-10">
        <aside class="md:w-64 flex-shrink-0">
          <div class="sticky top-24">
            <h4 id="sidebar-title" class="font-bold text-horabela-azul uppercase text-xs tracking-widest mb-4 border-b pb-2">Artigos</h4>
            <nav id="sidebar-links" class="space-y-1">
              <button v-for="art in currentCategory.articles" :key="art.id" @click="displayArticle(art)" class="w-full text-left px-4 py-2 rounded-lg text-sm text-gray-600 hover:bg-gray-100 hover:text-horabela-cobre transition-all font-medium">
                {{ art.label }}
              </button>
            </nav>
          </div>
        </aside>

        <article id="article-view" class="flex-1 bg-white p-6 md:p-10 rounded-2xl shadow-sm border border-gray-100 min-h-[600px]">
          <div id="article-content" ref="articleContent" class="animate-fadeIn" v-html="articleHtml"></div>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Ajuda',
  data() {
    return {
      searchQuery: '',
      HELP_DATA: {},
      currentCategory: { title: '', articles: [] },
      currentArticle: null,
      articleHtml: ''
    }
  },
  methods: {
    toggleFaq(el) { el.classList.toggle('active'); },
    loadCategory(key) {
      const cat = this.HELP_DATA[key];
      if (!cat) return;
      this.currentCategory = cat;
      this.$nextTick(() => {
        this.displayArticle(cat.articles[0]);
      });
    },
    displayArticle(art) {
      this.currentArticle = art;
    //   this.articleHtml = `\n        <h2 class="text-3xl font-bold text-horabela-azul mb-6">${art.label}</h2>\n        <div class="prose prose-slate max-w-none text-gray-600 mb-8 leading-relaxed">${art.content}</div>\n        <div class="video-placeholder">\n            <div class="text-center">\n                <div class="bg-white p-3 rounded-full shadow-lg mb-3 inline-block">\n                    <svg class="w-8 h-8 text-horabela-cobre" fill="currentColor" viewBox="0 0 20 20"><path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"></path></svg>\n                </div>\n                <p class="text-xs font-bold text-gray-400 uppercase tracking-widest">${art.media}</p>\n            </div>\n        </div>`;
    this.articleHtml = `\n        <h2 class="text-3xl font-bold text-horabela-azul mb-6">${art.label}</h2>\n        <div class="prose prose-slate max-w-none text-gray-600 mb-8 leading-relaxed">${art.content}</div>\n`;
      window.scrollTo({ top: 400, behavior: 'smooth' });
      this.$nextTick(() => {
        // Ensure global handlers exist for inline onclicks inside article content
        window.selectSearch = (catKey, artId) => this.selectSearch(catKey, artId);
        window.toggleFaq = (el) => this.toggleFaq(el);
      });
    },
    handleSearch() {
      const query = (this.searchQuery || '').toLowerCase();
      const container = this.$refs.searchResults;
      if (!container) return;
      if (query.length < 2) { container.classList.add('hidden'); return; }
      let results = '';
      Object.keys(this.HELP_DATA).forEach(catKey => {
        this.HELP_DATA[catKey].articles.forEach(art => {
          if (art.label.toLowerCase().includes(query) || art.content.toLowerCase().includes(query)) {
            results += `<div onclick="selectSearch('${catKey}', '${art.id}')" class="p-4 hover:bg-gray-50 cursor-pointer border-b border-gray-50 transition-colors">\n                                <span class="text-[10px] font-bold text-horabela-cobre uppercase block mb-1">${this.HELP_DATA[catKey].title}</span>\n                                <span class="text-sm font-semibold text-horabela-azul">${art.label}</span>\n                            </div>`;
          }
        });
      });
      container.innerHTML = results || '<div class="p-4 text-sm text-gray-400 italic">Nada encontrado...</div>';
      container.classList.remove('hidden');
      // expose selectSearch globally
      window.selectSearch = (catKey, artId) => this.selectSearch(catKey, artId);
    },
    selectSearch(catKey, artId) {
      this.loadCategory(catKey);
      const art = this.HELP_DATA[catKey].articles.find(a => a.id === artId);
      if (art) this.displayArticle(art);
      const container = this.$refs.searchResults; if (container) container.classList.add('hidden');
      this.searchQuery = '';
    }
  },
  mounted() {
    // set title
    document.title = 'Central de Ajuda | HoraBela';

    // populate HELP_DATA
    this.HELP_DATA = {
      primeiros: {
        title: "Passos Iniciais",
        articles: [
          {
            id: 'config-basica',
            label: "1. Organizar a Casa",
            content: `<h2>Primeiros passos para começar</h2>
                        <p>Para o sistema funcionar corretamente e você conseguir criar suas comandas, siga esta ordem:</p>
                        <ol class="list-decimal ml-5 mt-4 space-y-3">
                            <li><strong>Serviços:</strong> Cadastre tudo o que você oferece em <a href="https://app.horabela.com.br/servicos" target="_blank" class="text-horabela-cobre font-bold underline">Menu > Serviços</a>.</li>
                            <li><strong>Profissionais:</strong> Adicione sua equipe em <a href="javascript:void(0)" onclick="selectSearch('gestao', 'cad-profissionais')" class="text-horabela-cobre underline font-bold">Menu > Profissionais</a>.</li>
                            <li><strong>Produtos:</strong> Se vender itens como pomadas ou shampoos, cadastre em <a href="https://app.horabela.com.br/produtos" target="_blank" class="text-horabela-cobre font-bold underline">Menu > Produtos</a>.</li>
                        </ol>`,
            media: "GIF: Sequência de cadastros iniciais"
          },
          {
            id: 'site-agendamento',
            label: "2. Site de Agendamento Online",
            content: `<h2>Receba marcações pelo celular</h2>
                        <p>O HoraBela cria uma página exclusiva para seus clientes marcarem horário sozinhos.</p>
                        <ul class="list-disc ml-5 mt-4 space-y-2">
                            <li>Acesse <a href="https://app.horabela.com.br/configuracoes" target="_blank" class="text-horabela-cobre font-bold underline">Configurações</a> para preencher os dados do seu negócio.</li>
                            <li><strong>URL de Agendamento:</strong> Escolha o nome do seu site. Divulgue este link no seu Instagram e WhatsApp.</li>
                            <li><strong>Logo:</strong> Envie a imagem da sua empresa para aparecer na página de agendamento.</li>
                        </ul>
                        <div class="mt-4 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                            <strong>Dica:</strong> Confira sempre o seu <a href="https://app.horabela.com.br/horarios" target="_blank" class="underline font-bold">Horário de Funcionamento</a> antes de divulgar o link.
                        </div>`,
            // media: "VÍDEO: Configurando o site de agendamento"
          }
        ]
      },
      agenda: {
        title: "Agenda Diária",
        articles: [
          {
            id: 'acompanhar-agenda',
            label: "Como ver seus horários",
            content: `<h2>Sua Agenda em Tempo Real</h2>
                        <p>Na tela de <a href="https://app.horabela.com.br/agenda" target="_blank" class="text-horabela-cobre font-bold underline">Agenda</a>, você tem o controle total do dia:</p>
                        <ul class="list-disc ml-5 mt-4 space-y-2">
                            <li>Veja todos os agendamentos realizados e quem será o profissional.</li>
                            <li>Aba <strong>Últimos Agendamentos:</strong> Veja quem acabou de marcar pelo site online.</li>
                        </ul>`,
            media: "VÍDEO: Navegando pela Agenda"
          },
          {
            id: 'criar-agendamento',
            label: "Marcar Horário Manualmente",
            content: `<h2>O cliente ligou? Marque por aqui</h2>
                        <p>Se um cliente entrar em contato direto, vá em <a href="https://app.horabela.com.br/agenda" target="_blank" class="text-horabela-cobre font-bold underline">Agenda</a> e crie o agendamento manual.</p>
                        <p>Isso bloqueia o horário automaticamente no seu site online para ninguém marcar por cima.</p>`,
            media: "GIF: Criando agendamento manual"
          }
        ]
      },
      financeiro: {
        title: "Comandas e Pagamentos",
        articles: [
          {
            id: 'comandas',
            label: "Como cobrar o cliente",
            content: `<h2>Finalizando o Atendimento</h2>
                        <p>No <a href="https://app.horabela.com.br/comandas" target="_blank" class="text-horabela-cobre font-bold underline">Menu Comandas</a>, você registra o que foi vendido.</p>
                        <p>O sistema já calcula sozinho o valor do serviço e a <a href="javascript:void(0)" onclick="selectSearch('gestao', 'cad-profissionais')" class="underline font-bold">Comissão do Profissional</a>.</p>`,
            media: "VÍDEO: Como fechar uma comanda"
          }
        ]
      },
      relatorios: {
        title: "Resultados e Relatórios",
        articles: [
          {
            id: 'dash-estratetico',
            label: "Resumo do Negócio (Dashboard)",
            content: `<h2>Como está o seu faturamento?</h2>
                        <p>No <a href="https://app.horabela.com.br/business-dashboard" target="_blank" class="text-horabela-cobre font-bold underline">Dashboard Estratégico</a> você vê o coração da empresa:</p>
                        <ul class="list-disc ml-5 mt-4 space-y-2">
                            <li><strong>Faturamento do Mês:</strong> Quanto dinheiro entrou.</li>
                            <li><strong>Serviços Mais Vendidos:</strong> O que seus clientes mais procuram.</li>
                            <li><strong>Aniversariantes:</strong> Ótima chance para oferecer um presente e trazer o cliente de volta!</li>
                        </ul>`,
            media: "VÍDEO: Entendendo o Dashboard"
          },
          {
            id: 'rel-agendamentos',
            label: "Relatório de Agendamentos",
            content: `<h2>Histórico de Marcações</h2>
                        <p>Veja tudo o que foi marcado em <a href="https://app.horabela.com.br/relatorios/agendamento" target="_blank" class="text-horabela-cobre font-bold underline">Relatórios > Agendamentos</a>. Pode filtrar por profissional, data e serviço.</p>`,
            media: "GIF: Filtrando agendamentos"
          },
          {
            id: 'rel-comandas',
            label: "Relatório de Vendas (Comandas)",
            content: `<h2>Fechamento de Caixa</h2>
                        <p>No <a href="https://app.horabela.com.br/relatorios/comandas" target="_blank" class="text-horabela-cobre font-bold underline">Relatório de Comandas</a>, confira quanto entrou em Dinheiro, Cartão ou PIX e quanto deve pagar de comissão à equipe.</p>`,
            media: "GIF: Conferindo o fechamento do dia"
          }
        ]
      },
      gestao: {
        title: "Gestão de Equipe",
        articles: [
          {
            id: 'cad-profissionais',
            label: "Cadastro de Profissionais",
            content: `<h2>Equipe e Comissões</h2>
                        <p>Cadastre sua equipe em <strong>Menu > Profissionais</strong>.</p>
                        <ul class="list-disc ml-5 mt-4 space-y-2">
                            <li><strong>Comissão:</strong> Defina a porcentagem (%) que o profissional ganha. O cálculo é automático na <a href="javascript:void(0)" onclick="selectSearch('financeiro', 'comandas')" class="underline">Comanda</a>.</li>
                            <li><strong>Serviços:</strong> Não esqueça de vincular quais serviços cada profissional faz.</li>
                        </ul>`,
            media: "GIF: Cadastro de colaborador"
          },
          {
            id: 'cad-servicos',
            label: "Cadastro de Serviços",
            content: `<h2>Preço e Tempo de Atendimento</h2>
                        <p>Configure seus serviços em <a href="https://app.horabela.com.br/servicos" target="_blank" class="text-horabela-cobre font-bold underline">Serviços</a>.</p>
                        <p><strong>Dica do Tempo:</strong> Se for 30 minutos, coloque Horas: 0 e Minutos: 30. Se for 1h e 30min, coloque Horas: 1 e Minutos: 30.</p>`,
            media: "GIF: Cadastro de serviços"
          },
          {
            id: 'clientes',
            label: "Gestão de Clientes",
            content: `<h2>Ficha do Cliente</h2>
                        <p>Em <a href="https://app.horabela.com.br/clientes" target="_blank" class="text-horabela-cobre font-bold underline">Menu > Clientes</a>, pesquise por nome ou telefone para ver o histórico de tudo o que ele já fez no salão.</p>`,
            media: "GIF: Histórico do cliente"
          }
        ]
      },
      faq: {
        title: "Perguntas Frequentes",
        articles: [
          {
            id: 'faq-list', label: "Dúvidas Comuns",
            content: `
                        <div class="faq-item" onclick="toggleFaq(this)">
                            <div class="faq-question">Onde eu visualizo a comissão para realizar o pagamento ao profissional? <svg class="w-4 h-4 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                            <div class="faq-answer">Você deve ir ao menu <a href="https://app.horabela.com.br/relatorios/comandas" target="_blank" class="underline font-bold">Relatórios > Comandas</a>. Filtre pela data desejada e você poderá visualizar a comissão de cada profissional e todas as comandas realizadas por eles.</div>
                        </div>
                        <div class="faq-item" onclick="toggleFaq(this)">
                            <div class="faq-question">Posso agendar duas vezes no mesmo horário? <svg class="w-4 h-4 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                            <div class="faq-answer">Sim! Apenas você (administrador) pode fazer isso no <strong>Menu > Criar Agendamento</strong>. Se o horário não aparecer, use a opção "Selecionar qualquer horário" e digite manualmente. <em>Obs: Clientes no site online nunca conseguirão marcar no mesmo horário ocupado.</em></div>
                        </div>
                        <div class="faq-item" onclick="toggleFaq(this)">
                            <div class="faq-question">Esqueci de cadastrar um cliente, posso fazer na hora de agendar? <svg class="w-4 h-4 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                            <div class="faq-answer">Com certeza! No momento de criar o agendamento ou a comanda, basta digitar o nome e telefone. O sistema fará o <strong>Cadastro Rápido</strong> e salvará o cliente automaticamente.</div>
                        </div>
                        <div class="faq-item" onclick="toggleFaq(this)">
                            <div class="faq-question">O sistema calcula comissão sobre produtos? <svg class="w-4 h-4 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                            <div class="faq-answer">Sim! No cadastro do Profissional, você define a comissão para serviços e para produtos. Ao fechar a Comanda, o HoraBela faz a separação desses valores no seu relatório.</div>
                        </div>
                        <div class="faq-item" onclick="toggleFaq(this)">
                            <div class="faq-question">Onde encontro o meu link de agendamento online? <svg class="w-4 h-4 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                            <div class="faq-answer">Você encontra no <a href="https://app.horabela.com.br/agenda" target="_blank" class="underline font-bold text-horabela-cobre">Menu > Agenda</a>. Se ainda não criou seu endereço personalizado, defina-o em <a href="https://app.horabela.com.br/configuracoes" target="_blank" class="underline">Configurações</a>.</div>
                        </div>
                        <div class="faq-item" onclick="toggleFaq(this)">
                            <div class="faq-question">Posso bloquear um horário da agenda? <svg class="w-4 h-4 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                            <div class="faq-answer">Sim! Vá ao <a href="https://app.horabela.com.br/agenda" target="_blank" class="underline font-bold">Menu Agenda</a> e clique no botão <strong>Bloquear Agenda</strong>. Você pode bloquear um período para folgas, almoço ou profissionais específicos.</div>
                        </div>`,
            media: "Fim das Dúvidas Frequentes"
          }
        ]
      }
    };

    // set default category
    this.loadCategory('primeiros');

    // expose helpers globally for inline HTML event handlers
    window.selectSearch = (catKey, artId) => this.selectSearch(catKey, artId);
    window.toggleFaq = (el) => this.toggleFaq(el);

    // hide search results when clicking outside
    document.addEventListener('click', (e) => {
      const input = document.getElementById('search-input');
      const container = this.$refs.searchResults;
      if (!input) return;
      if (!e.target.closest('#search-input') && container) container.classList.add('hidden');
    });
  }
}
</script>

<style scoped>
body { font-family: 'Inter', sans-serif; }
.bg-horabela-cobre { background-color: #B5836A; }
.text-horabela-cobre { color: #B5836A; }
.bg-horabela-azul { background-color: #2D3748; }
.text-horabela-azul { color: #2D3748; }
.border-horabela-cobre { border-color: #B5836A; }
.video-placeholder {
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    aspect-ratio: 16 / 9;
    border: 2px dashed #cbd5e1;
    transition: all 0.3s;
}
.video-placeholder:hover { border-color: #B5836A; background: #f8fafc; }
/* Estilos do FAQ */
.faq-item { border-bottom: 1px solid #edf2f7; cursor: pointer; }
.faq-question { display: flex; justify-content: space-between; align-items: center; padding: 1.25rem 0; font-weight: 600; color: #2D3748; }
.faq-answer { max-height: 0; overflow: hidden; transition: all 0.3s ease-out; color: #4a5568; line-height: 1.6; }
.faq-item.active .faq-answer { max-height: 500px; padding-bottom: 1.25rem; }
.faq-item.active svg { transform: rotate(180deg); color: #B5836A; }
</style>
